import { FloatButton } from "antd";
import { useSelector } from "react-redux";
import { css } from "@emotion/css";
import { useUnreadSupportCount } from "../../store/selectors/supportNotificationSelectors";
import MessageQuestionIcon from "../../Theme/CustomIcons/Icons/Support,Like,Question/MessageQuestionIcon";
import { useMemo } from "react";

const SupportUnreadBadge = ({ setVisible }) => {
  const notifications =
    useSelector((state) => state?.notificationsList)?.notifyInfo || [];
  const unreadSupportCount = useUnreadSupportCount();
  const unreadCount = useMemo(
    () => unreadSupportCount,
    [unreadSupportCount, notifications]
  );
  const themeDefault = useSelector((state) => state.themeDefault);

  return (
    <div
    // style={{
    //   position: "fixed",
    //   bottom: "24px",
    //   right: "24px",
    //   zIndex: 100000,
    // }}
    >
      {/* Badge */}
      {unreadCount ? (
        <span
          style={{
            position: "absolute",
            top: "-66px",
            right: "35px",
            background: "#ffbb96",
            color: "black",
            fontSize: "12px",
            fontWeight: 600,
            minWidth: "20px",
            height: "20px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 0 0 1px rgba(0,0,0,0.4)",
            padding: "2px 3px",
            zIndex: 100000,
          }}
        >
          {unreadCount}
        </span>
      ) : (
        <></>
      )}

      {/* Float Button */}
      <FloatButton
        shape="circle"
        className={css`
          .ant-float-btn-body {
            background: linear-gradient(
              200deg,
              ${themeDefault?.info?.newConfig?.colorPrimaryShades?.[4] ||
              "#FFBB96"},
              ${themeDefault?.info?.newConfig?.colorPrimaryShades?.[7] ||
              "#FF7A45"}
            ) !important;
          }
          width: 60px;
          height: 60px;
          animation: supportPop 0.25s ease-out;

          @keyframes supportPop {
            0% {
              transform: scale(0.6);
              opacity: 0;
            }
            60% {
              transform: scale(1.1);
              opacity: 1;
            }
            100% {
              transform: scale(1);
            }
          }
        `}
        onClick={() => setVisible(true)}
        style={{ bottom: 24 }}
        icon={
          <MessageQuestionIcon
            style={{
              fontSize: "24px",
              color: "white",
              marginLeft: "-1.5px",
            }}
          />
        }
      />
    </div>
  );
};

export default SupportUnreadBadge;
